import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { WebservicesService } from "../webservices/webservices.service";

@Injectable()
export class ConfigurationService { 

  constructor(
    private webservice: WebservicesService,
    private config: ConfigService
  ) {
    // this.logger.log("ConfigurationProvider")
  }

  callGetAvatars() {
    return this.webservice.get('configuration/get-avatars');
  }

  //Note: The url without a "/" at the end is not supported by springboot.
  springbootCheck(url: string): string{
    if (url[url.length - 1] != "/") return url = url + "/";
    return url;   
  }


}